export function serializeValue(v) {
  if (v == null) return v;
  if (typeof v?.toDate === "function") {
    try {
      return v.toDate().toISOString();
    } catch {
      return String(v);
    }
  }
  if (v instanceof Date) return v.toISOString();
  if (Array.isArray(v)) return v.map(serializeValue);
  if (typeof v === "object" && v.constructor === Object) {
    const o = {};
    for (const [k, val] of Object.entries(v)) o[k] = serializeValue(val);
    return o;
  }
  return v;
}

export function cellText(value) {
  if (value == null) return "";
  if (typeof value?.toDate === "function") {
    try {
      return value.toDate().toLocaleString();
    } catch {
      return String(value);
    }
  }
  if (typeof value === "object") {
    const s = JSON.stringify(serializeValue(value));
    return s.length > 120 ? `${s.slice(0, 120)}…` : s;
  }
  return String(value);
}

export function inferFieldType(value) {
  if (value === null || value === undefined) return "null";
  if (typeof value?.toDate === "function") return "timestamp";
  if (value instanceof Date) return "timestamp";
  if (Array.isArray(value)) return "array";
  if (typeof value === "object") return "map";
  if (typeof value === "boolean") return "boolean";
  if (typeof value === "number") return "number";
  return "string";
}

export function collectColumns(rows) {
  const cols = new Set(["id"]);
  rows.forEach((r) => {
    Object.keys(r.data || {}).forEach((k) => cols.add(k));
  });
  const list = [...cols].sort();
  list.splice(list.indexOf("id"), 1);
  list.unshift("id");
  return list;
}

export function estimateBytes(rows) {
  try {
    return new Blob([JSON.stringify(rows.map((r) => ({ id: r.id, ...r.data })))]).size;
  } catch {
    return 0;
  }
}

export function parseEditableValue(raw, type) {
  if (type === "null") return null;
  if (type === "boolean") return raw === "true" || raw === true;
  if (type === "number") return Number(raw);
  if (type === "timestamp") return new Date(raw);
  if (type === "array" || type === "map") return JSON.parse(raw);
  return String(raw);
}
